import styled from "styled-components";
import { GlobalWrapper, TextWrapper } from "../../../shared/Styles/Wrappers";

export const Container = styled(GlobalWrapper)`
  overflow: hidden;
`;

export const Wrapper = styled(TextWrapper)``;
